import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_28 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_29 = { class: "indicator-label" }
const _hoisted_30 = { class: "indicator-progress" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_editor = _resolveComponent("editor")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateFaq')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.faqSchema,
            "initial-values": {
          answerAr: _ctx.faq.answerAr ?? '',
          answerEn: _ctx.faq.answerEn ?? '',
        }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('arabicQuestion')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      as: "textarea",
                      type: "text",
                      name: "questionAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('questionArLang'),
                      modelValue: _ctx.faq.questionAr,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.faq.questionAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "questionAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('arabicAnswer')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, { name: "answerAr" }, {
                      default: _withCtx(({ field, errorMessage }) => [
                        _createVNode(_component_editor, {
                          apiKey: "w5u1bctf39vva9gmakhdohcnyu5masw0l071cxuykwj2sns0",
                          init: {
                    height: 100,
                    menubar: true,
                    directionality: 'ltr',
                    language: 'ar',
                    setup(editor) {
                      editor.on('init', () => {
                        editor.getBody().setAttribute('dir', 'ltr');
                        editor.getBody().style.textAlign = 'left';
                      });
                    },
                    content_css:
                      'https://fonts.googleapis.com/css2?family=Cairo:wght@600&display=swap',
                    font_formats: `
          Cairo='Cairo', sans-serif;
          Arial=arial,helvetica,sans-serif;
          Courier New=courier new,courier,monospace;
          Georgia=georgia,palatino;
          Times New Roman=times new roman,times;
          Verdana=verdana,geneva;
        `,
                    content_style: `
          body, * { font-family: 'Cairo', sans-serif !important; }
        `,
                    plugins: [
                      'advlist autolink lists link image charmap preview anchor',
                      'searchreplace visualblocks visualchars code fullscreen',
                      'insertdatetime media table emoticons hr pagebreak',
                      'wordcount save directionality template codesample',
                      'nonbreaking toc autosave spellchecker help quickbars',
                    ],
                    toolbar: [
                      'undo redo | blocks fontselect fontsizeselect',
                      'bold italic underline strikethrough forecolor backcolor',
                      'alignleft aligncenter alignright alignjustify | outdent indent',
                      'bullist numlist | link image media table codesample | hr pagebreak',
                      'charmap emoticons | fullscreen preview save print | code help',
                    ].join(' | '),
                    quickbars_selection_toolbar:
                      'bold italic | quicklink h2 h3 blockquote',
                    quickbars_insert_toolbar: 'image media table',
                    toolbar_mode: 'sliding',
                    contextmenu:
                      'link image inserttable | cell row column deletetable',
                    image_advtab: true,
                    image_caption: true,
                    file_picker_types: 'image media file',
                    automatic_uploads: true,
                    paste_data_images: true,
                    relative_urls: false,
                    remove_script_host: false,
                    convert_urls: true,
                  },
                          modelValue: field.value,
                          "onUpdate:modelValue": field.onChange,
                          onBlur: field.onBlur
                        }, null, 8, ["init", "modelValue", "onUpdate:modelValue", "onBlur"]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(errorMessage), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('englishQuestion')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      as: "textarea",
                      type: "text",
                      name: "questionEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('questionEnLang'),
                      modelValue: _ctx.faq.questionEn,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.faq.questionEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "questionEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('englishAnswer')), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_Field, { name: "answerEn" }, {
                      default: _withCtx(({ field, errorMessage }) => [
                        _createVNode(_component_editor, {
                          apiKey: "w5u1bctf39vva9gmakhdohcnyu5masw0l071cxuykwj2sns0",
                          init: {
                    height: 100,
                    menubar: true,
                    directionality: 'ltr',
                    language: 'en',
                    setup(editor) {
                      editor.on('init', () => {
                        editor.getBody().setAttribute('dir', 'ltr');
                        editor.getBody().style.textAlign = 'left';
                      });
                    },
                    content_css:
                      'https://fonts.googleapis.com/css2?family=Cairo:wght@600&display=swap',
                    font_formats: `
          Cairo='Cairo', sans-serif;
          Arial=arial,helvetica,sans-serif;
          Courier New=courier new,courier,monospace;
          Georgia=georgia,palatino;
          Times New Roman=times new roman,times;
          Verdana=verdana,geneva;
        `,
                    content_style: `
          body, * { font-family: 'Cairo', sans-serif !important; }
        `,
                    plugins: [
                      'advlist autolink lists link image charmap preview anchor',
                      'searchreplace visualblocks visualchars code fullscreen',
                      'insertdatetime media table emoticons hr pagebreak',
                      'wordcount save directionality template codesample',
                      'nonbreaking toc autosave spellchecker help quickbars',
                    ],
                    toolbar: [
                      'undo redo | blocks fontselect fontsizeselect',
                      'bold italic underline strikethrough forecolor backcolor',
                      'alignleft aligncenter alignright alignjustify | outdent indent',
                      'bullist numlist | link image media table codesample | hr pagebreak',
                      'charmap emoticons | fullscreen preview save print | code help',
                    ].join(' | '),
                    quickbars_selection_toolbar:
                      'bold italic | quicklink h2 h3 blockquote',
                    quickbars_insert_toolbar: 'image media table',
                    toolbar_mode: 'sliding',
                    contextmenu:
                      'link image inserttable | cell row column deletetable',
                    image_advtab: true,
                    image_caption: true,
                    file_picker_types: 'image media file',
                    automatic_uploads: true,
                    paste_data_images: true,
                    relative_urls: false,
                    remove_script_host: false,
                    convert_urls: true,
                  },
                          modelValue: field.value,
                          "onUpdate:modelValue": field.onChange,
                          onBlur: field.onBlur
                        }, null, 8, ["init", "modelValue", "onUpdate:modelValue", "onBlur"]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(errorMessage), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                (_ctx.can('update', 'settings'))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_30, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_31
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema", "initial-values"])
        ])
      ]))
    : _createCommentVNode("", true)
}